import React, { FC } from 'react';
import { PageData } from 'types/Page';
import ShiftTargetProjectOfProfileSelectOption from './ShiftTargetProjectOfProfileSelectOption';
import { Select } from '@kontentino/ui';
import { useTranslation } from 'react-i18next';

type Props = {
  pages: PageData[];
  onProfileChange: (id: number) => void;
  value?: PageData;
};

const formatPageToSelectValue = (page: PageData) => ({
  label: page.name,
  value: page.id,
  logoSrc: page.logo?.src ?? '',
  type: page.type,
});

const ShiftTargetProjectPageSelector: FC<Props> = ({
  pages,
  onProfileChange,
  value,
}) => {
  const { t } = useTranslation();
  return (
    <Select
      value={value ? formatPageToSelectValue(value) : null}
      placeholder={t('selectSocialMediaProfile')}
      options={pages.map((option) => formatPageToSelectValue(option))}
      components={{
        SingleValue: (option) => (
          <div className="tw-absolute tw-left-2">
            <ShiftTargetProjectOfProfileSelectOption option={option.data} />
          </div>
        ),
      }}
      formatOptionLabel={(option) => (
        <ShiftTargetProjectOfProfileSelectOption option={option} />
      )}
      onChange={(option) => {
        if (option?.value) {
          onProfileChange(option.value);
        }
      }}
      isSearchable
      menuPortalTarget={document.body}
      styles={{
        menuPortal: (styles) => ({
          ...styles,
          zIndex: 1010,
        }),
        valueContainer: (css, state) => ({
          ...css,
          input: {
            position: 'absolute',
          },
        }),
      }}
    />
  );
};

export default ShiftTargetProjectPageSelector;
